import { render, staticRenderFns } from "./CustodiesTable.vue?vue&type=template&id=4074ff90&"
import script from "./CustodiesTable.vue?vue&type=script&lang=js&"
export * from "./CustodiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports